import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Flex, theme } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import { INTEGRATIONS_ROUTE } from '../SearchPerformanceRoutes';

const STRINGS = {
  cardTitle: 'Manage synced domains',
  back: 'Back to Integrations',
};

function GscManageDomainsSkeleton() {
  const { token } = theme.useToken();
  const navigate = useNavigate();

  return (
    <Flex vertical gap={token.marginLG}>
      <Card
        title={STRINGS.cardTitle}
        loading
        styles={{ body: { paddingTop: token.padding, paddingBottom: token.padding } }}
      />
      <Button
        type="link"
        icon={<ArrowLeftOutlined />}
        style={{ paddingLeft: 0 }}
        onClick={() => navigate(INTEGRATIONS_ROUTE)}
      >
        {STRINGS.back}
      </Button>
    </Flex>
  );
}

export default GscManageDomainsSkeleton;
